import * as _ from "lodash";
import React, { useState, useContext } from "react";
import { Box } from "@mui/system";
import {
    Card,
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TablePagination,
    CircularProgress,
    SelectChangeEvent,
} from "@mui/material";
import TableToolBar from "./tableauToolbar";
import TableListHead from "./tableHeader";
import SearchNotFound from "./searchNotFound";
import { useTranslation } from "react-i18next";
import { getHeaderLabel } from "../../../../utils/App";
import { UserReservationService } from "../services/UserReservationService"; 
import { UserContext } from "../../../../contexts/AppContext";
import { DataReservationAdmin, IReservationReq } from "../../../../Models/reservationModels";
import { makeStyles } from "@material-ui/core";
import { EStatus, getStatusLabel } from "../../../../utils/enum";
import { CurrencyContext } from "../../../../contexts/AppContext";
import moment from "moment";
import { ConvertedDeviseWithoutMoneySign } from "../../../../utils/CurrencyConvertFunction";
import { EPaymentMethod } from "../../../../utils/enum/PaymentMethod";
import { Link } from "react-router-dom";

function descendingComparator(a: any, b: any, orderBy: string) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order: string, orderBy: string) {
    return order === "desc"
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(
    array: any[],
    comparator: (a: any, b: any) => number,
    query: string,
    fkey: string
) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        if (fkey === "travellerNumber") {
            return array.filter(
                (el) => Number(el.travellerNumber) === Number(query)
            );
        } else if (fkey === "totalAmount") {
            return array.filter(
                (el) => Number(el.totalAmount) === Number(query)
            );
        } else if (fkey === "bookingDate") {
            return array.filter(
                (el) =>
                    moment(el.bookingDate)
                        .format("DD/MM/YYYY hh:mmA")
                        .indexOf(query) !== -1
            );
        } else if (fkey === "dateCheckIn") {
            return array.filter(
                (el) => dateToString(el.dateCheckIn).indexOf(query) !== -1
            );
        } else if (fkey === "dateCheckOut") {
            return array.filter(
                (el) => dateToString(el.dateCheckOut).indexOf(query) !== -1
            );
        } else {
            return _.filter(
                array,
                (_reserv) =>
                    (_.get(_reserv, fkey) ?? "")
                        .toLowerCase()
                        .indexOf(query.toLowerCase()) !== -1
            );
        }
    }
    return stabilizedThis.map((el) => el[0]);
}

const dateToString = (nDate: Date) => {
    const cDate = new Date(nDate);
    const day = cDate.getDate();
    const mouth = cDate.getMonth() + 1;
    const year = cDate.getFullYear();

    return `${day < 10 ? 0 : ""}${day}-${mouth < 10 ? 0 : ""}${mouth}-${year}`;
};

const userReservationService = new UserReservationService();
export const BookingListAdmin = () => {
    const { t, i18n } = useTranslation<'common'>();
    i18n.on("languageChanged", function (lng) {
        moment.locale(lng);
    });
    
    const userContext = useContext(UserContext);
    const { user } = userContext;
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;

    const TABLE_HEAD = [
        {
            id: "bookingDate",
            label: getHeaderLabel("bookingDate"),
            alignRight: false,
        },
        {
            id: "property",
            label: getHeaderLabel("property"),
            alignRight: false,
        },
        {
            id: "roomsBooked",
            label: getHeaderLabel("roomsBooked"),
            alignRight: false,
        },
        {
            id: "address",
            label: getHeaderLabel("address"),
            alignRight: false,
        },
        {
            id: "traveller",
            label: getHeaderLabel("traveller"),
            alignRight: false,
        },
        {
            id: "dateCheckIn",
            label: getHeaderLabel("dateCheckIn"),
            alignRight: false,
        },
        {
            id: "dateCheckOut",
            label: getHeaderLabel("dateCheckOut"),
            alignRight: false,
        },
        {
            id: "status",
            label: getHeaderLabel("status"),
            alignRight: false,
        },
        {
            id: "paymentMethod",
            label: getHeaderLabel("paymentMethod"),
            alignRight: false,
        },
        {
            id: "advanceAmount",
            label: getHeaderLabel("advanceAmount"),
            alignRight: true,
        },
        {
            id: "remainingAmount",
            label: getHeaderLabel("remainingAmount"),
            alignRight: true,
        },
        {
            id: "totalAmount",
            label: getHeaderLabel("totalAmount"),
            alignRight: true,
        },
        {
            id: "serviceFee",
            label: getHeaderLabel("serviceFee"),
            alignRight: false,
        },
        {
            id: "_id",
            label: getHeaderLabel("idReservation"),
            alignRight: false,
        },
       
    ];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState("desc");
    const [orderBy, setOrderBy] = useState("dateCheckIn");
    const [filterName, setFilterName] = useState("");
    const [fcolumn, setFColumn] = useState(TABLE_HEAD[0].id);
    const [reservationList, setReservationList] = useState<DataReservationAdmin[]>([]);
    const [gettingList, setGettingList] = useState(false);
    const classes = useStyle();

    const handleFilterByName = (event: any) => {
        setFilterName(event.target.value);
    };

    const handleChange = (event: SelectChangeEvent) => {
        setFColumn(event.target.value);
    };

    const handleRequestSort = (_event: any, property: string) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (_event: any, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

     function formatCurrency(amount: number, currency: any): string {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: currency === 'EUR' ? 2 : 0,
          maximumFractionDigits: currency === 'EUR' ? 2 : 0
        });
        return formatter.format(amount);
      }


    React.useEffect(() => {
        const fetchReservations = async () => {
        setGettingList(true);
                try {

                    
                     const resp = await userReservationService.getAllMyTransactions(user._id);
                     console.log("Raw API Response:", resp);
                    console.log("Type of resp:", typeof resp);
                    console.log("Is Array?", Array.isArray(resp));
                    
                    // Extract the actual array data (handles both direct array and { data: [...] } responses)
            let reservationsArray: IReservationReq[] = [];
            if (Array.isArray(resp)) {
                reservationsArray = resp;
            } else if (resp?.data && Array.isArray(resp.data)) {
                reservationsArray = resp.data;
            } else {
                console.error("Unexpected API response structure:", resp);
                setReservationList([]);
                return;
            }

            // Handle empty array case
            if (!reservationsArray.length) {
                console.log("No reservations found (empty array)");
                setReservationList([]);
                return;
            }
            
                    // Explicitly type the processed reservations
                   const reservationPromises = reservationsArray.map(
                        async (reservation: IReservationReq): Promise<DataReservationAdmin> => {
                            const totalAmount = Number(reservation.price) || 0;
                            const advanceAmount = Number(reservation.advancePaymentAmount) || 0;
                            const remainingAmount = totalAmount - advanceAmount;
                            const serviceFee = totalAmount / 10;

                            // Parallelize currency conversions
                            const [convertedTotal, convertedPaid, convertedRemaining] = await Promise.all([
                                ConvertedDeviseWithoutMoneySign(
                                    reservation.announce?.devise || "EUR",
                                    currency,
                                    totalAmount
                                ),
                                ConvertedDeviseWithoutMoneySign(
                                    reservation.announce?.devise || "EUR",
                                    currency,
                                    advanceAmount
                                ),
                                ConvertedDeviseWithoutMoneySign(
                                    reservation.announce?.devise || "EUR",
                                    currency,
                                    remainingAmount
                                )
                            ]);

                            return {
                                _id: reservation._id ?? "",
                                property: reservation.announce?.property?.name ?? "",
                                address: `${reservation.announce?.property?.address?.quartier ?? ""}, ${reservation.announce?.property?.address?.city?.name ?? ""}`,
                                traveller: `${reservation.traveller?.firstName ?? ""} ${reservation.traveller?.lastName ?? ""} (${reservation.travellerAdultTotal + reservation.travellerChildTotal})`,
                                dateCheckIn: new Date(reservation.dateCheckIn),
                                dateCheckOut: new Date(reservation.dateCheckOut),
                                status: getStatusLabel(reservation.status[reservation.status.length - 1].status),
                                paymentMethod: reservation?.paymentPlan?.isBNPL ? "BNPL" : t("label.advancePayment"),
                                advanceAmount,
                                remainingAmount,
                                serviceFee,
                                totalAmount,
                                bookingDate: new Date(reservation.createdAt || Date.now()),
                                roomsBooked: reservation.roomsBooked ?? 1,
                            };
                        }
                    );

                    const processedReservations = await Promise.all(reservationPromises);
                    setReservationList(processedReservations);

                } catch (error) {
            console.error("Error fetching or processing reservations:", error);
            setReservationList([]);
        } finally {
            setGettingList(false);
        }
    };

    fetchReservations();
}, [currency, user._id]);

      

    const emptyRows =
        page > 0
            ? Math.max(0, (1 + page) * rowsPerPage - reservationList.length)
            : 0;
    const filteredReservation = applySortFilter(
        reservationList,
        getComparator(order, orderBy),
        filterName,
        fcolumn
    );
    const isReservNotFound = filteredReservation.length === 0;

    return (
        <Box flex={1}>
            <Card>
                <TableToolBar
                    numSelected={0}
                    filterName={filterName}
                    onFilterName={handleFilterByName}
                    currentCol={fcolumn}
                    onColChange={handleChange}
                    colLists={TABLE_HEAD}
                />
                <TableContainer
                    sx={{ minWidth: 800, padding: 4 }}
                    className={classes.tableau}
                >
                    <Table>
                        <TableListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={reservationList.length}
                            numSelected={0}
                            onRequestSort={handleRequestSort}
                        />
                        {!gettingList && (
                            <TableBody>
                                {filteredReservation
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row) => {
                                        const {
                                            _id,
                                            property,
                                            roomsBooked,
                                            address,
                                            traveller,
                                            dateCheckIn,
                                            dateCheckOut,
                                            status,
                                            paymentMethod,
                                            advanceAmount,
                                            remainingAmount,
                                            totalAmount,
                                            serviceFee,
                                            bookingDate,
                                        } = row;
                                        
                                        return (
                                            <TableRow
                                                hover
                                                key={_id}
                                                tabIndex={-1}
                                            >
                                                <TableCell>
                                                    {moment(bookingDate).format("DD/MM/YYYY hh:mmA")}
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="subtitle2">
                                                        {property}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {roomsBooked}
                                                </TableCell>
                                                <TableCell>
                                                    {address}
                                                </TableCell>
                                                <TableCell>
                                                    {traveller}
                                                </TableCell>
                                                <TableCell>
                                                    {dateToString(dateCheckIn)}
                                                </TableCell>
                                                <TableCell>
                                                    {dateToString(dateCheckOut)}
                                                </TableCell>
                                                <TableCell>
                                                    {status}
                                                </TableCell>
                                                <TableCell>
                                                    {paymentMethod}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {formatCurrency(advanceAmount, currency)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {formatCurrency(remainingAmount, currency)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {formatCurrency(totalAmount, currency)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {formatCurrency(serviceFee, currency)}
                                                </TableCell>
                                                <TableCell>
                                                    <Link 
                                                        to={`/booking-receipt-${_id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={classes.bookingLink}
                                                    >
                                                        {_id}
                                                    </Link>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && !gettingList && (
                                    <TableRow
                                        style={{ height: 53 * emptyRows }}
                                    >
                                        <TableCell colSpan={12} />
                                    </TableRow>
                                )}
                            </TableBody>
                        )}
                        {isReservNotFound && !gettingList && (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={12}
                                        sx={{ py: 3 }}
                                    >
                                        <SearchNotFound
                                            sx={{ py: 3 }}
                                            searchQuery={filterName}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                        {gettingList && (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={12}
                                        sx={{ py: 3 }}
                                    >
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={reservationList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={t("listTable.labels.lignesParPage")}
                />
            </Card>
        </Box>
    );
};

const useStyle = makeStyles((theme) => ({
    tableau: {
        [theme.breakpoints.down("xs")]: {
            minWidth: "auto!important",
        },
    },
    head: {
        [theme.breakpoints.down("xs")]: {
            whiteSpace: "nowrap",
        },
    },
    bookingLink: {
        textDecoration: 'underline',
        color: '#890608',
        cursor: 'pointer',
        '&:hover': {
        color: '#a82a2a', // Optional hover effect
        }
    }
}));